export default __webpack_public_path__ + "static/g-01-d8fcf0ce71d0c937b71a880e4dfa147d.png";